export const GET_ALL_PROJECT_CATALOGUE: String = "GET_ALL_PROJECT_CATALOGUE";
export const PROJECT_DATA_LOADING: String = "PROJECT_DATA_LOADING";
export const PROJECT__CATALOGUE_DATA: String = "PROJECT__CATALOGUE_DATA";
export const GETONE_CATALOGUE_DATA: String = "GETONE_CATALOGUE_DATA";
export const LOADING: String = "LOADING";
